export const handleColectionFilters = (url, filterName) => {

    // Extract the path from the URL, ignoring query parameters and the domain
    const path = new URL(url).pathname;
    
    // Split the path to analyze its segments
    const segments = path.split('/').filter(Boolean); // Remove any empty segments
    
    // Assume the last segment is where filters are applied
    const lastSegment = segments[segments.length - 1];
  
    // Check if the last segment contains '+', indicating existing filters
    const hasPlus = lastSegment.includes('+');
  
    // Determine how to apply the new filter
    let newUrl;
    if (hasPlus) {
      // If there's a '+', append the new filter with '+'
      newUrl = `${url}+${filterName}`;
    } else {
      // If there's no '+', append the new filter with '/'
      // Check if the last segment already matches a filter pattern to decide on using '/' or '+'
      const shouldUsePlusInstead = /[\w-]+_[\w-]+/.test(lastSegment); // Simple regex to match 'filter_category'
      if (shouldUsePlusInstead) {
        newUrl = `${url}+${filterName}`;
      } else {
        newUrl = `${url}/${filterName}`;
      }
    }
  
    window.location.href = newUrl;

}